import axios from 'axios';
import { IResponse } from '~/services/api/types';
import {
  ITriageCounters,
  ITriageRequests,
  ITriageRequest,
  ITriageRequestsFilters,
  ITriageRequestUpdate,
  ITriageSelectors,
} from './types';

const apiUrl = 'triage';

export const getCounters = (): IResponse<ITriageCounters> =>
  axios({
    method: 'get',
    url: `${apiUrl}/counters`,
  });

export const getRequests = (params: ITriageRequestsFilters): IResponse<ITriageRequests> =>
  axios({
    method: 'get',
    url: `${apiUrl}/requests`,
    params,
  });

export const getSelectors = (): IResponse<ITriageSelectors> =>
  axios({
    method: 'get',
    url: `${apiUrl}/selectors`,
  });

export const getRequestByNoteId = (noteId: number): IResponse<ITriageRequest> =>
  axios({
    method: 'get',
    url: `${apiUrl}/requests/by-note-id/${noteId}`,
  });

export const updateRequestByNoteId = (
  noteId: number,
  data: ITriageRequestUpdate,
): IResponse<ITriageRequest> =>
  axios({
    method: 'put',
    url: `${apiUrl}/requests/by-note-id/${noteId}`,
    data,
  });

export default {};
